import moment from 'moment';
import React from 'react';
const TimeFormat = (cells) => {
  const devicename = cells?.row?.original?.devicename
  return (
    <span title={devicename || undefined}>
      {moment(cells.value).format('hh:mm:ss A')}
    </span>
  )
}

const StatusFormat = (cells) => {
  const text = cells.value.toUpperCase();
  return <span style={{ "color": text === 'ACTIVE' ? "green" : text === 'IDLE' ? "#87CEEB" : text === 'ON EVALUATION' ? "orange" : "red", fontWeight: 'bold' }}>{text}</span>
}

const InvalidFormat = (cells) => {
  const isInvalid = cells?.row?.original?.isinvalid
  const reason = cells?.row?.original?.invalidreason
  return isInvalid ? (
    <span
      className="badge bg-danger font-size-12"
      title={reason || "Marked as invalid"}
      style={{ cursor: "help" }}
    >
      Invalid
    </span>
  ) : (
    <span className="badge bg-success font-size-12">Valid</span>
  )
}

export {
  TimeFormat,
  StatusFormat,
  InvalidFormat
}